import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';
import { StoresCustomerModel } from '../models/stores-customer.model';

export class StoresCustomersApiService extends ApiService {
  static endpoint = 'stores/customers';

  /**
   * @param {object} data
   * @param {builderCallback} builderCallback
   * @param {object} config
   * @returns {Promise<ApiResponse<StoresCustomerModel>>}
   * @public
   */
  static async post(data, builderCallback = null, config = {}) {
    return HttpApiClient.post(this.buildUrl(), data, {
      ...config,
      dataModel: StoresCustomerModel,
      useThemeApi: true,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }
}
